if (!customElements.get('fancy-slider')) {
  customElements.define(
    'fancy-slider',
    class FancySlider extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          mainSwiperDiv: null,
          mainSwiper: null,
          thumbsSwiperDiv: null,
          thumbsSwiper: null,
          slides: null
        }
      }

      connectedCallback() {

        this.elements.mainSwiperDiv = this.querySelector('.main-swiper');
        this.elements.thumbsSwiperDiv = this.querySelector('.thumbs-swiper');
        this.elements.slides = document.querySelectorAll('.fs-slider__copy');


        // Initialize Swipers if the necessary elements are present
        if (this.elements.mainSwiperDiv && this.elements.thumbsSwiperDiv) {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => {
              this.initSwipers();
              this.updateCopyVisibility();
            });
          } else {
            // Fallback for browsers that don't support requestIdleCallback
            setTimeout(() => {
              this.initSwipers();
              this.updateCopyVisibility();
            }, 1000);
          }
          
        }
      }

      initSwipers() {
        // Initialize thumbs Swiper
        this.elements.thumbsSwiper = new Swiper(this.elements.thumbsSwiperDiv, {
          spaceBetween: 10,
          slidesPerView: 2,
          loop: true,
        });

        // Initialize main Swiper with thumbs control
        this.elements.mainSwiper = new Swiper(this.elements.mainSwiperDiv, {
          autoplay: {
            delay: 5000,
          },
          spaceBetween: 10,
          slidesPerView: 1.2,
          loop: true,
          thumbs: {
            swiper: this.elements.thumbsSwiper
          },
          pagination: {
            el: this.querySelector('.pagination'),
            type: this.querySelector('fraction'),
            clickable: true
          },
          navigation: {
            nextEl: this.querySelector('.button-next'),
            prevEl: this.querySelector('.button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 1
            }
          },
        });

        // Update copy visibility on slide change
        this.elements.mainSwiper.on("slideChange", () => {
          this.updateCopyVisibility();  
        });

      }

      updateCopyVisibility() {
        var slide = document.querySelector(`.fs-slider__copy[data-slide="${this.elements.mainSwiper.realIndex}"]`);
       
        this.elements.slides.forEach((slide) => {
          slide.classList.remove('fs-slider__copy--active');
        });
        if (slide) {
          slide.classList.add('fs-slider__copy--active');
        }
      }
    }
  );
}